import { render, staticRenderFns } from "./_favList.vue?vue&type=template&id=1ac91aba&lang=pug&"
import script from "./_favList.vue?vue&type=script&lang=js&"
export * from "./_favList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports